<template>
  <div class="pb-40 box grow scrollable">
    <div class="sticky">
      <el-row :gutter="20" class="">
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
            <HeaderCard :title="title" :col="12" :showAddButton="false"></HeaderCard>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="text-right">
              <el-row>
                <!-- Sauvegarde -->
                <el-col>
                    <el-button type="primary" size="small" @click="save()">{{$t('CMSBlog.save')}}</el-button>
                    <el-button size="small" @click="back()">{{$t('CMSBlog.cancel')}}</el-button>

                    <el-button size="small" class="ml-10" icon="el-icon-delete" v-if="isEditionMode" @click="handleDelete"></el-button>
                </el-col>
              </el-row>
          </el-col>
        </el-row>
    </div>
    <div class="list box grow" style="height:80%;">
      <el-form ref="form" :model="model" :rules="rules">
        <el-row :gutter="20">
          <!-- Colonne de gauche -->
           <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
             <el-card>
               <el-row class="mr-20" :gutter="20">
                 <!-- Author -->
                 <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <el-form-item :label="$t('CMSBlog.blog.author')" prop="user">
                       <SelectAdminUser
                        role="Auteur"
                        :currentUser="{id: 2}"
                        @selected="handleAuthorSelect"/>
                     </el-form-item>
                 </el-col>

                 <!-- Controls -->
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" style="text-align:right">
                    <el-row justify="end">
                      <el-col>
                        <el-checkbox size="small" class="m-10" v-model="model.published" :label="$t('CMSBlog.blog.published')" border @change="v=> handlePublishing(v)"></el-checkbox>
                      </el-col>
                      <el-col v-if="isEditionMode">
                          <span class="secondary-text fs-12">{{$t('common.createdAt')}} : {{_moment(model.createdDate, 'lll')}}</span>
                      </el-col>
                      <el-col v-if="isEditionMode">
                          <span class="secondary-text fs-12">{{$t('common.updatedAt')}} : {{_moment(model.updatedDate, 'lll')}}</span>
                      </el-col>
                      <el-col v-if="model.published">
                          <span class="secondary-text fs-12" v-if="!editPublishedDate">{{$t('common.publishedAt')}} : <el-link type="primary" @click="handleEditPublishedDate(true)" class="secondary-text fs-12">{{_moment(model.publishedDate, 'lll')}} <i class="el-icon-edit"></i></el-link></span>
                          <el-date-picker
                            ref="publishDateComponent"
                            v-else
                            size="mini"
                            v-model="model.publishedDate"
                            style="width:170px"
                            type="datetime"
                            @change="handlePublishedDateChange"
                            placeholder="Selectionnez date et horaire">
                          </el-date-picker>
                      </el-col>
                    </el-row>
                  </el-col>
                </el-row>
              <el-row>
                <el-col>
                  <el-form-item :label="$t('CMSBlog.blog.type')" prop="type">
                    <el-select
                      v-model="model.type"
                      :no-match-text="emptyTxt"
                      :no-data-text="emptyTxt"
                      :placeholder="placeholder">
                       <el-option
                         v-for="type in blogTypes"
                         :key="type.id"
                         :label="type.name[lang]"
                         :value="type.id">
                       </el-option>
                     </el-select>
                   </el-form-item>
                </el-col>
              </el-row>
                <el-row class="mr-20" :gutter="20">
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <el-form-item :label="$t('CMSBlog.blog.titleFr')" prop="titleFr">
                        <el-input v-model="model.titleFr" @change=" v => handleTitleChanged('fr', v)"></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <el-form-item :label="$t('CMSBlog.blog.titleEn')" prop="titleFr">
                        <el-input v-model="model.titleEn" @change=" v => handleTitleChanged('en', v)"></el-input>
                      </el-form-item>
                  </el-col>
                  <!-- Slug -->
                   <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                     <div v-if="!indChangeSlug">
                       <span class="fs-14 m-10 pb-20">
                         Slug URL:
                       </span>
                       <span class="fs-14 secondary-text">
                         /{{model.slugFr}}
                       </span>
                       <el-button v-if="model.titleFr != null && model.titleFr != ''" type="text" icon="el-icon-edit" class="ml-10" @click="handleChangeSlug"/>
                     </div>
                      <el-form-item :label="$t('CMSProduct.slug')" prop="slugFr" v-else>
                         <el-input v-model="model.slugFr"></el-input>
                       </el-form-item>
                   </el-col>



                   <!-- Slug -->
                    <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                      <div v-if="!indChangeSlug">
                        <span class="fs-14 m-10 pb-20">
                          Slug URL:
                        </span>
                        <span class="fs-14 secondary-text">
                          /{{model.slugEn}}
                        </span>
                        <el-button v-if="model.titleEn != null && model.titleEn != ''" type="text" icon="el-icon-edit" class="ml-10" @click="handleChangeSlug"/>
                      </div>
                       <el-form-item :label="$t('CMSProduct.slug')" prop="slugEn" v-else>
                          <el-input v-model="model.slugEn"></el-input>
                        </el-form-item>
                    </el-col>

                  <!-- Video Link FR-->
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('CMSBlog.blog.videoTitleFr')">
                      <el-input :placeholder="$t('CMSBlog.blog.videoPlaceholder')" v-model="model.videoLinkFr">
                        <template slot="prepend">Http://</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <!-- Video Link EN-->
                  <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                    <el-form-item :label="$t('CMSBlog.blog.videoTitleEn')">
                      <el-input :placeholder="$t('CMSBlog.blog.videoPlaceholder')" v-model="model.videoLinkEn">
                        <template slot="prepend">Http://</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <!-- Image principale -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

                    <el-form-item>
                      {{$t('CMSBlog.blog.mainImage')}}
                      <div class="text-center" v-if="model.main==null && galeryType!=null">
                        <ImageUploadWidget :typeId="galeryType.id" @select="v => handleGalerySelection(v, 'main')"></ImageUploadWidget>
                      </div>
                      <div class="main card-base card-alt" v-if="model.main!=null">
                        <img v-lazy="model.main.link" alt="card image">
                      </div>
                      <span v-if="model.main!=null"><el-button type="text" @click="removeMain">{{$t('CMSProvider.main.remove')}}</el-button></span>

                    </el-form-item>
                  </el-col>

                  <!-- Summary -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                  <el-collapse v-model="contentTabs" >
                    <el-collapse-item :title="$t('CMSBlog.blog.shortDescription')" name="1">
                        <el-form-item >
                          <el-tabs v-model="languageTabs" type="border-card">
                            <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                              <quill-editor v-model="model.summary[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                                ref="noteEditor"
                                :options="editorOptions">
                              </quill-editor>
                            </el-tab-pane>
                          </el-tabs>
                        </el-form-item>

                    </el-collapse-item>
                    <el-collapse-item :title="$t('CMSBlog.blog.content')" name="2">
                      <!-- Contenu -->
                        <el-form-item >
                          <el-tabs v-model="languageTabs" type="border-card">
                            <el-tab-pane v-for="l in cms_languages" :key="l.id" :label="l.name" :name="l.code">
                              <quill-editor v-model="model.content[l.code]" style="margin-top:40px;border:1px solid #EBEEF5;min-height:200px;"
                                ref="noteEditor"
                                :options="editorOptions">
                              </quill-editor>
                            </el-tab-pane>
                          </el-tabs>
                        </el-form-item>

                    </el-collapse-item>
                  </el-collapse>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="mt-10">
                    <el-form-item :label="$t('CMSBlog.blog.relatedProducts')">
                      <SelectMultipleProduct @change="handleProductsChange" :products="model.relatedProducts" :showCMSName="false" :summary="true" :emptyText="$t('CMSBlog.blog.noRelatedProducts')" :placeholder="$t('common.searchToAdd')"/>
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" class="mt-10">
                    <el-form-item :label="$t('CMSBlog.blog.relatedProviders')">
                      <SelectMultipleProvider @change="handleProvidersChange" :providers="model.relatedProviders" :showCMSName="false" :summary="true" :emptyText="$t('CMSBlog.blog.noRelatedProviders')" :placeholder="$t('common.searchToAdd')"/>
                    </el-form-item>
                  </el-col>
                  <!-- Gallerie -->
                  <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">

                    <el-form-item>
                      {{$t('CMSBlog.blog.galeries')}}
                      <div class="text-center" v-if="galeryType!=null">
                        <ImageUploadWidget  :enabledMutlipleImageSelection="true" :typeId="galeryType.id" @select="v => handleGalerySelection(v, 'galleries')"></ImageUploadWidget>
                      </div>
                       <GaleryMasonry :showCode="false" :showDescription="false" :showInGalery="false" :selection="false" :edition="false" :multiple="false" :images="model.galeries" class="m-20" @delete="handleRemoveGalleryItem" @show="show"></GaleryMasonry>
                     </el-form-item>
                  </el-col>
                </el-row>
              </el-card>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <img-viewer  ref="viewer" :images="model.galeries"/>
    <GalleryDialog :dialogVisible="galleryDialogVisible" :selection="true" :multiple="enabledMutlipleImageSelection" @close="closeGaleryialog" @select="handleGalerySelection"></GalleryDialog>
  </div>
</template>
<script>
import moment from 'moment'
import HeaderCard from '@/components/header-card'
import GalleryDialog from './components/gallery-dialog'
import GaleryMasonry from './components/galery-masonry'
import imageUtil from '@/utils/image-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import cmsAPI from '@/services/API/cmsAPI'
import ImgViewer from "@/components/ImgViewer";
import ImageUploadWidget from "./components/image-upload-widget"
import SelectAdminUser from '@/components/users/select-admin-user'
import SelectMultipleProduct from '@/components/product/select-multiple-product'
import SelectMultipleProvider from '@/views/pages/CMS/components/select-multiple-cms-provider'


export default {
	name: 'Blog-Editor',
	data() {
		return {
      editPublishedDate : false,
      oldPublishedDate: null,
      contentTabs : ["2"],
      galleryDialogVisible : false,
      enabledMutlipleImageSelection : false,
      loading : false,
      indChangeSlug: false,
      model : {
        published: false,
        publishedDate: null,
        id : null,
        titleFr : null,
        titleEn : null,
        slugFr: null,
        slugEn: null,
        content : {fr : '', en:''},
        summary : {fr : '', en:''},
        main : null,
        galeries : [],
        lockVersion : null,
        type : null,
        attributes : [],
        tags: [],
        videoLinkFr : null,
        videoLinkEn : null,
        author: null,
        createdDate: null,
        updatedDate: null,
        relatedProviders: [],
        relatedProducts: [],
      },
      galeryTypes : [],
      addProviderDialogVisible : false,
      providerTypes : [],
      languageTabs : "fr",
      loadingLogo : false,
      // editorOptions: {
			// 	theme: 'snow',
      //   placeholder: test,
      //   modules: {
			// 		toolbar: [
			// 			['bold', 'italic', 'underline', 'strike', 'link']
			// 		]
			// 	}
			// },
      rules : {
        titleFr : [
          { required: true, message: 'Veuillez saisir un nom', trigger: 'blur' }
        ],
        type : [
          { required: true, message: 'Veuillez sélectionner un type', trigger: 'blur' }
        ],
      }
		}
	},
  components : {
    HeaderCard,
    GalleryDialog,
    GaleryMasonry,
    ImgViewer,
    ImageUploadWidget,
    SelectAdminUser,
    SelectMultipleProduct,
    SelectMultipleProvider,
  },
  computed : {
    placeholder () {
      return this.$i18n.t('common.select.placeholder');
    },
    emptyTxt () {
      return this.$i18n.t('common.select.empty');
    },
    editorOptions () {
      return  {
				theme: 'snow',
        placeholder: this.$i18n.t('CMSBlog.blog.contentPlaceholder'),
        modules: {
					toolbar: [
						['bold', 'italic', 'underline', 'strike', 'link']
					]
				}
			}
    },
    title () {
      if (this.isEditionMode) {
        return this.$i18n.t('CMSBlog.editPost')
      }
      return this.$i18n.t('CMSBlog.newPost')
    },
    galeryType(){
      return _.find(this.galeryTypes, t=>{return t.code=='BLOG'})
    },
		blogId(){
			return this.$route.params.blogId!=null ? parseInt(this.$route.params.blogId) : null;
		},
    cms_languages(){
      return _.filter(this.languages, l=>{return l.cms_language});
    },
    lang(){
      return this.$i18n.locale
    },
    isEditionMode(){
      return this.blogId!=null;
    },
    ...mapState('controlData',['languages','blogTypes']),
    ...mapGetters(['getLocale']),
  },
  methods : {
    handleProvidersChange (providers) {
      this.model.relatedProviders.splice(0, this.model.relatedProviders.length);
      this.model.relatedProviders.push(...providers);
    },
    handleProductsChange (products) {
      this.model.relatedProducts.splice(0, this.model.relatedProducts.length);
      this.model.relatedProducts.push(...products);
    },
    handleAuthorSelect (author) {
      this.model.author = author;
    },
    back(){
      this.$router.go(-1);
    },
    handlePublishedDateChange () {
      this.handleEditPublishedDate(false);
    },
    handleEditPublishedDate (editInd) {
      this.editPublishedDate = editInd;
      if (editInd) {
        if (this.model.publishedDate == null) {
          this.model.publishedDate = new moment().format();
        }
        this.oldPublishedDate = this.model.publishedDate;
        this.$nextTick(() => this.$refs['publishDateComponent'].focus());
      }
    },
    handlePublishing (published){
      if(this.isEditionMode){
        this.loading = true;
        this.model.published = published;

        if (published) {
          this.model.publishedDate = new moment().format();
        }
        // return this.save();
      } else {
        this.model.published = published;
        this.model.publishedDate = new moment().format();
      }


    },
    _moment(datetime, format='LL'){
      return moment(datetime).format(format);

		},
    handleDelete() {
      this.$confirm("Êtes vous sûr de vouloir supprimer l'article ?", 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Annuler',
          type: 'warning'
        })
        .then(() => cmsAPI.deleteBlog(this.model.id))
        .then(() => this.$message.success("L'article a été supprimé avec succès!"))
        // .then(() => this.invalidate())
        .then(() => this.back())
        .catch(err => {
          if(err=="cancel"){
            this.$message('Suppression annulée!');
          }else{
            console.log(err);
            this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
          }
        })
    },
    handleChangeSlug () {
      this.indChangeSlug = true;
    },
    handleTitleChanged (lang, value){
      if (lang === 'fr') {
        this.model.slugFr = _.kebabCase(value);
      } else {
        this.model.slugEn = _.kebabCase(value);
      }

    },
    show(index){
      this.$refs.viewer.show(
        this.model.galeries,
        index
      );
    },
    validateForm(){
      return this.$refs['form'].validate()
        .then(valid=>{
          if(valid) return true;
          else return Promise.reject(false);
        })
    },
    save (){
      this.validateForm()
        .then(()=>{
          let postData = {};

          postData.slug = {
            fr: this.model.slugFr,
            en: this.model.slugEn,
          }

          postData.user = {
            id: _.get(this.model, 'author.id'),
          }

          postData.title = {
            fr: this.model.titleFr,
            en: this.model.titleEn,
          }

          postData.videoLink = {
            fr: this.model.videoLinkFr,
            en: this.model.videoLinkEn,
          }
          postData.images = [];

          if(this.model.galeries!= null && this.model.galeries.length>0){
            _.forEach(this.model.galeries, g=>{postData.images.push({id:g.id})});
          }

          postData.mainImage = this.model.main != null ? {id:this.model.main.id} : undefined;

          postData.type = {
            id: this.model.type,
          }

          postData.attributes = []; // no attributes for providers (for the moment)

          postData.content = this.model.content;
          postData.description = this.model.summary;

          postData.published = this.model.published;
          postData.publishedDate = this.model.publishedDate;

          postData.relatedProducts = _.map(this.model.relatedProducts, product => ({id: product.id}));
          postData.relatedProviders = _.map(this.model.relatedProviders, provider => ({id: provider.id}));

          if(!this.isEditionMode){
            return cmsAPI.saveBlog(postData)
              .then(providerCreated=>{
                this.$message.success(this.$i18n.t('CMSBlogs.blogCreated'));
                this.model.lockVersion +=1;
                this.$router.push('/settings/CMS/blogs');
              }).catch(err=>{
                console.log(err);
                this.$message.error(this.$i18n.t('CMSBlogs.blogCreationFailed'));
              })
          }else{
            postData.lockVersion = this.model.lockVersion;
            return cmsAPI.updateBlog(this.model.id, postData)
              .then(blogUpdated=>{
                this.$message.success(this.$i18n.t('CMSBlogs.blogUpdated'));
                this.$router.push('/settings/CMS/blogs');
              }).catch(err=>{
                console.log(err);
                this.$message.error(this.$i18n.t('CMSBlogs.blogUpdateFailed'));
              })
          }
        })

    },
    handleRemoveGalleryItem(id){
      let index = _.findIndex(this.model.galeries, g=>{return g.id==id});
      this.model.galeries.splice(index,1);
    },
    removeLogo(){
      this.model.logo=null;
    },
    removeMain(){
      this.model.main=null;
    },
    handleGalerySelection(asset, usedFor){
      if(usedFor=='logo'){
        this.model.logo = asset[0];
      }else if(usedFor=='main'){
        this.model.main = asset[0];
      }else if(usedFor=='galleries'){
        this.model.galeries.push(...asset);
      }
    },
    closeGaleryialog(){
      this.galleryDialogVisible=false;
    },
    initContent(){
      _.forEach(this.cms_languages, l=>{
        this.model.content[l.code] = '';
      })
    },
    getBlog(blogId){
      return cmsAPI.getCMSBlog(this.blogId)
    },
    setModel(blog){
      this.model.id= blog.id;
      this.model.published = blog.published;
      this.model.publishedDate = blog.publishedDate != null ? blog.publishedDate : new moment().format();
      this.model.titleFr = _.get(blog, 'title.fr');
      this.model.titleEn = _.get(blog, 'title.en');

      this.model.slugFr = _.get(blog, 'slug.fr');
      this.model.slugEn = _.get(blog, 'slug.en');

      this.model.content.fr = _.get(blog, 'content.fr');
      this.model.content.en = _.get(blog, 'content.en');

      this.model.summary.fr = _.get(blog, 'description.fr');
      this.model.summary.en = _.get(blog, 'description.en');

      this.model.videoLinkFr = _.get(blog, 'videoLink.fr');
      this.model.videoLinkEn = _.get(blog, 'videoLink.en');

      this.model.main = blog.mainImage;

      this.model.galeries = blog.images;
      this.model.type = _.get(blog, 'type.id');
      this.model.author = blog.user;

      this.model.lockVersion = blog.lockVersion;
      this.model.createdDate = blog.createdDate;
      this.model.updatedDate = blog.updatedDate;
      this.model.relatedProducts = blog.relatedProducts;
      this.model.relatedProviders = blog.relatedProviders;
    },
    fetchCMSGalleryTypes(){
      return cmsAPI.fetchCMSGalleryTypes()
        .then(types=>{
          this.galeryTypes.push(...types);
        })
    },
    fetchRelatedProducts (){

    },
    fetchRelatedProviders (){

    },
    ...mapActions('controlData',['fetchLanguages', 'fetchBlogTypes']),
  },
  mounted(){
    if(this.isEditionMode){
      return this.getBlog(this.blogId)
        .then(blog=>{
          this.setModel(blog);
          this.fetchRelatedProducts();
          this.fetchRelatedProviders();
        })
        .catch((err) => {
          this.back();
          this.$message.error('Une erreur est survenue. Veuillez réessayer plus tard');
        })
    }else{
      this.initContent();
    }
  },
  created(){
    return Promise.all([
      this.fetchLanguages(),
      this.fetchBlogTypes(this.getLocale),
      this.fetchCMSGalleryTypes(),
    ])

  }

}
</script>
<style lang="scss" scoped>
@import '../../../assets/scss/_variables';

.add-galery{
  cursor:pointer;
}

.sticky {
  position: -webkit-sticky;
  position: sticky;
  top:0px;
  z-index:1000;
  background-color:#f3f7fa;
}

.main{
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width:100%;

  line-height:normal;

  img {
    width: 100%;
    max-width: 100%;
  }
}

.item {
  padding: 20px;
  //margin: 20px 0;
  margin-bottom: 20px;
  //border-radius: 5px;
  // opacity: .85;
  transition: all .25s;

  /* masonry */
  //display: inline-block;
  box-sizing: border-box;
  box-shadow: 0px 0px 0px 1px $text-color-accent;
  width: 200px;
  line-height:normal;
  img {
    // width: 100%;
    // max-width: 100%;
  }

}

</style>
